var n = function(e) {
  try {
    return e();
  } catch {
    return;
  }
};
export {
  n as safeProbe
};
